<div class="bodyMain-wrap width-100" *ngIf="data[0].id==1 || data[0].id==2; else fdesk">
  <!-- <div class="bodyMain-wrap width-100" ngIf="data[0].id==1 || data[0].id==2; else fdesk"></div> -->
  <div class="px-0 dashboard-mainContainer">
    <div class="row">
      <div class="col-md-12 welcome-wrapper pe-5">
        <h1>DOCTOR PROFILE</h1>
      </div>
    </div>
    <div class="row mainContainer">
      <div class="dashboardBox-wrapper widthAdjust40">
        <div class="whiteBg_container">
          <div class="d-flex flex-between">

            <span><img [src]="physician && physician?.ppurl ? physician?.ppurl : ''" class="profileImage">
            </span>
            <!-- <span><img src="/assets/images/userSqre.svg" alt="user"></span> -->
            <div class="switchInfo">
              <div class="d-flex align-center onlineStats">

                <div class="content contentStch">
                  <p>Go Online</p>
                  <!-- <label class="switchSmall m5">
                    <input type="checkbox" class="custom-control-input" id="enable" [checked]="consultChecked"
                      (change)="checkValue((consultChecked = !consultChecked))" />
                    <small></small>
                  </label> -->
                  <label class="m5 custom-control custom-switch d-inline-block">
                    <input type="checkbox" class="custom-control-input" id="enable" [checked]="consultChecked"
                      (change)="checkValue((consultChecked = !consultChecked))" />
                    <label class="custom-control-label" for="enable"></label>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="usrName">
            <div class="d-flex flex-between">
              <div class="infoName">
                <p>Hello Dr. {{phyfname?phyfname:''}} {{phylname?phylname:''}}</p>
                <div class="d-flex calsndInfo align-center">
                  <span class="bgBlu">
                    <img src="/assets/images/calendar.svg" alt="user">
                  </span>
                  <div class="contentDflex">
                    <p>Appointment Calendar</p>
                    <a routerLink="/doctor-calendar"><span>Manage Calendar</span></a>
                  </div>
                </div>
              </div>
              <div class="rightProfl">
                <!-- <span><img src="/assets/images/FrameCircle.svg" alt="user"></span> -->
                <!-- <a href="" data-bs-toggle="tooltip" data-bs-placement="bottom" title={{this.msg}}> -->
                <span data-bs-toggle="tooltip" data-bs-placement="bottom" title={{this.msg}}>
                  <circle-progress class="circle__progress" [percent]=weightage [animation]="true"
                    [animationDuration]="800" [startFromZero]="true" [showInnerStroke]="true" [titleFontSize]="'28'"
                    [titleFontWeight]="'500'" [unitsFontSize]="'28'" [unitsFontWeight]="'300'"
                    [subtitle]="'Profile Completetion'" [subtitleFontSize]="'8'" [lazy]="false"
                    [backgroundColor]="'white'" [radius]="'50'" [maxPercent]="'100'" [unitsColor]="'#483500'"
                    [outerStrokeWidth]="'10'" [outerStrokeColor]=color [innerStrokeColor]="'black'"
                    [titleColor]="'#483500'" [subtitleColor]="'#483500'" [showSubtitle]=false [showInnerStroke]=false
                    [startFromZero]=false></circle-progress></span>
                <!-- </a> -->
                <a href="#" [routerLink]="['/profile/physicians-profile/'+uid]">
                  <p>Complete your Profile</p>
                </a>

              </div>
            </div>
          </div>
        </div>
        <div class="whiteBg_container flotWidth mt-3">
          <h3 class="fontSize19">Patient List</h3>

          <!-- <form [formGroup]="form">
            <div class="input-group">

              <input class="form-control border-end-0 border rounded-pill" type="search" formControlName="name"
                placeholder="search by Patient name" id="example-search-input">
              <span class="input-group-append">
                <img src="/assets/images/searchIcon.svg" class="" alt="search" (click)="search()"> -->
          <!-- <button class="btn btn-outline-secondary bg-white border-bottom-0 border rounded-pill ms-n5"
                  style="color:rgb(24, 21, 190)" type="submit" (click)="search()">
                  <i class="fa fa-search"></i>
                </button> -->
          <!-- </span>
            </div>
          </form> -->

          <form [formGroup]="form">
            <div class="formInput">
              <div class="flexInput">
                <!-- <button class="btn btn-outline-secondary bg-white border-bottom-0 border rounded-pill ms-n5"
                  style="color:rgb(24, 21, 190)" type="submit" (click)="search()">
                  <i class="fa fa-search"></i>
                </button> -->
                <!-- <input class="form-control border-end-0 border rounded-pill" type="search" formControlName="name"
                  placeholder="search by Patient name" id="example-search-input">-->
                <span><img src="/assets/images/searchIcon.svg" alt="search" (click)="search()"></span>
                <input type="text" (keyup.enter)="search()" formControlName="name" id="name"
                  placeholder="Search by Patient name">
              </div>
              <span class="closeIcn"><img src="/assets/images/closeCircle.svg" alt="search"
                  onclick="document.getElementById('name').value = ''" (click)="searchuser()"></span>
            </div>
          </form>

          <ul *ngIf="pat_users.length >0; else noRecord" class="frmInputList flotWidth">
            <li *ngFor="let fd of pat_users">
              <p>{{fd?.first_name}}&nbsp;{{fd?.last_name}} / {{fd?.contact_no?fd.contact_no:''}}
                {{fd?.email_id?'/ '+fd.email_id:''}}
              </p>
            </li>
          </ul>
        </div>

      </div>
      <div class="dashboardBox-wrapper widthAdjust60">
        <div class="row">
          <div class="col-md-6 col-xs-12 infoBoxWrapper paddinglaftRight">
            <div class="whiteBg_container">
              <div class="d-flex flex-between">
                <div class="cntntInfo">
                  <h2 style="text-align: left;">Today’s Appointments (Online)</h2>
                  <div class="d-flex flex-between">
                    <div class="d-flex flex-column countinNmbr">
                      <label>{{dashboardvalues1?.online_physician_request_count?dashboardvalues1.online_physician_request_count:'0'}}</label>
                      <span><a routerLink="/appointments/request">Requests</a></span>
                    </div>
                    <div class="d-flex flex-column countinNmbr">
                      <label>{{dashboardvalues1?.online_physician_schedule_count?dashboardvalues1.online_physician_schedule_count:'0'}}</label>
                      <span><a routerLink="appointment/consultation">Scheduled</a></span>
                    </div>
                  </div>
                </div>
                <div class="colrBox">
                  <img src="/assets/images/appointment.svg" alt="user">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xs-12 infoBoxWrapper paddinglaftRight">
            <div class="whiteBg_container">
              <div class="d-flex flex-between">
                <div class="cntntInfo">
                  <h2 style="text-align: left;">Today’s Appointments (In-Person)</h2>
                  <div class="d-flex flex-between">
                    <div class="d-flex flex-column countinNmbr">
                      <label>{{dashboardvalues1?.inperson_physician_schedule_count?dashboardvalues1.inperson_physician_schedule_count:'0'}}</label>
                      <span><a routerLink="appointment/checkin">Scheduled</a></span>
                    </div>
                    <div class="d-flex flex-column countinNmbr">
                      <label>{{dashboardvalues1?.inperson_physician_checkin_count?dashboardvalues1.inperson_physician_checkin_count:'0'}}</label>
                      <span><a routerLink="appointment/consultation">Check In</a></span>
                    </div>
                  </div>
                </div>
                <div class="colrBox redClr">
                  <img src="/assets/images/medicalIcon.svg" alt="user">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xs-12 infoBoxWrapper paddinglaftRight">
            <div class="whiteBg_container">
              <div class="d-flex flex-between">
                <div class="cntntInfo">
                  <h2 style="text-align: left;">Pending Appointments</h2>
                  <div class="d-flex flex-between">
                    <div class="d-flex flex-column countinNmbr">
                      <label>{{todaysOnlineAppointmentallCount?todaysOnlineAppointmentallCount:0}}</label>
                      <span><a routerLink="/appointment/consultation"> Online</a></span>
                    </div>
                    <div class="d-flex flex-column countinNmbr">
                      <label>{{todaysInpersonAppointmentallCount}}</label>
                      <span><a routerLink="/appointments/Checkin"> In-Person</a></span>
                    </div>
                  </div>
                </div>
                <div class="colrBox orange">
                  <img src="/assets/images/pendingMedicl.svg" alt="user">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xs-12 infoBoxWrapper paddinglaftRight">
            <div class="whiteBg_container">
              <div class="d-flex flex-between">
                <div class="cntntInfo">
                  <h2 style="text-align: left;">Completed Appointments
                  </h2>
                  <div class="d-flex flex-between">
                    <div class="d-flex flex-column countinNmbr">
                      <label>{{dashboarddata?.COMPLETED_APPOINTMENT_ONLINE.length}}</label>
                      <span> <a routerLink="/appointments/past">Online</a></span>
                    </div>
                    <div class="d-flex flex-column countinNmbr">
                      <label>{{dashboarddata?.COMPLETED_APPOINTMENT_INPERSON.length}}</label>
                      <span> <a routerLink="/appointments/past">In-Person</a></span>
                    </div>
                  </div>
                </div>
                <div class="colrBox greenClr">
                  <img src="/assets/images/tickIcon.svg" alt="user">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xs-12 infoBoxWrapper paddinglaftRight">
            <div class="whiteBg_container">
              <div class="d-flex flex-between">
                <div class="cntntInfo">
                  <h2 style="text-align: left;">Appointment Status</h2>
                  <div class="d-flex flex-between">
                    <div class="d-flex flex-column countinNmbr">
                      <label>{{dashboarddata?.ONLINE_FOLLOWUP_APPOINTMENT.length}}</label>
                      <span>Follow up</span>
                    </div>
                    <div class="d-flex flex-column countinNmbr">
                      <label>{{dashboarddata?.CANCEL_APPOINTMENT_ONLINE.length}}</label>
                      <span><a routerLink="/appointments/request"> Cancelled</a></span>
                    </div>
                  </div>
                </div>
                <div class="colrBox purple">
                  <img src="/assets/images/yellowIcon.svg" alt="user">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xs-12 infoBoxWrapper paddinglaftRight">
            <div class="whiteBg_container">
              <div class="d-flex flex-between">
                <div class="cntntInfo">
                  <h2 style="text-align: left;">Patients Count</h2>
                  <div class="d-flex flex-between">
                    <div class="d-flex flex-column countinNmbr">
                      <label>{{dashboarddata?.PATIENT_ONLINE.length}}</label>
                      <span>Online</span>
                    </div>
                    <div class="d-flex flex-column countinNmbr">
                      <label>{{dashboarddata?.PATIENT_INPERSON.length}}</label>
                      <span><a routerLink="/profile/search/patient"> In-person</a></span>
                    </div>
                  </div>
                </div>
                <div class="colrBox yellowClr">
                  <img src="/assets/images/OrangeIcon.svg" alt="user">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 monetseTable mt-0">
            <!-- <div class="whiteBg_container">
              <h3 class="fontSize19">Pending Online Appointments Requests</h3>
              <div class="table-responsive drTable">
                <table class="table align-middle">
                  <thead>
                    <tr>
                      <th>
                        <p>Type</p>
                      </th>
                      <th>
                        <p>Date & Time</p>
                      </th>
                      <th>
                        <p>Patient Name</p>
                      </th>
                      <th>
                        <p>Physician Name</p>
                      </th>
                      <th>
                        <p class="centerlaign">Action</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><span><img src="/assets/images/bell.svg" alt="icon"></span></td>
                      <td>
                        <p>31/01/2024 | 14:20:00</p>
                      </td>
                      <td>
                        <p>Patient Name</p>
                      </td>
                      <td>
                        <p>Dr Pasva Manikandan</p>
                      </td>
                      <td>
                        <p class="actionBtn">
                          <a href="#"><img src="/assets/images/checkMarks.svg" alt="icon"></a>
                          <a href="#"><img src="/assets/images/editIcon.svg" alt="icon"></a>
                          <a href="#"><img src="/assets/images/deleteTable.svg" alt="icon"></a>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td><span><img src="/assets/images/bell.svg" alt="icon"></span></td>
                      <td>
                        <p>Date & Time</p>
                      </td>
                      <td>
                        <p>Patient Name</p>
                      </td>
                      <td>
                        <p>Physician Name</p>
                      </td>
                      <td>
                        <p class="actionBtn">
                          <a href="#"><img src="/assets/images/checkMarks.svg" alt="icon"></a>
                          <a href="#"><img src="/assets/images/editIcon.svg" alt="icon"></a>
                          <a href="#"><img src="/assets/images/deleteTable.svg" alt="icon"></a>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td><span><img src="/assets/images/bell.svg" alt="icon"></span></td>
                      <td>
                        <p>31/01/2024 | 14:20:00</p>
                      </td>
                      <td>
                        <p>Patient Name</p>
                      </td>
                      <td>
                        <p>Dr Pasva Manikandan</p>
                      </td>
                      <td>
                        <p class="actionBtn">
                          <a href="#"><img src="/assets/images/checkMarks.svg" alt="icon"></a>
                          <a href="#"><img src="/assets/images/editIcon.svg" alt="icon"></a>
                          <a href="#"><img src="/assets/images/deleteTable.svg" alt="icon"></a>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td><span><img src="/assets/images/bell.svg" alt="icon"></span></td>
                      <td>
                        <p>Date & Time</p>
                      </td>
                      <td>
                        <p>Patient Name</p>
                      </td>
                      <td>
                        <p>Physician Name</p>
                      </td>
                      <td>
                        <p class="actionBtn">
                          <a href="#"><img src="/assets/images/checkMarks.svg" alt="icon"></a>
                          <a href="#"><img src="/assets/images/editIcon.svg" alt="icon"></a>
                          <a href="#"><img src="/assets/images/deleteTable.svg" alt="icon"></a>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td><span><img src="/assets/images/bell.svg" alt="icon"></span></td>
                      <td>
                        <p>Date & Time</p>
                      </td>
                      <td>
                        <p>Patient Name</p>
                      </td>
                      <td>
                        <p>Physician Name</p>
                      </td>
                      <td>
                        <p class="actionBtn">
                          <a href="#"><img src="/assets/images/checkMarks.svg" alt="icon"></a>
                          <a href="#"><img src="/assets/images/editIcon.svg" alt="icon"></a>
                          <a href="#"><img src="/assets/images/deleteTable.svg" alt="icon"></a>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> -->

            <app-aptreq-dash></app-aptreq-dash>
            <div class="pb-2"></div>
            <app-checkin-dash></app-checkin-dash>
            <!-- <h3 class="fontSize19">Today's Inperson Appointments</h3>
              <div class="table-responsive drTable">
                <table class="table align-middle">
                  <thead>
                    <tr>
                      <th>
                        <p>Date & Time</p>
                      </th>
                      <th>
                        <p>Patient Name</p>
                      </th>
                      <th>
                        <p>Physician Name</p>
                      </th>
                      <th>
                        <p class="centerlaign">Action</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <p>31/01/2024 | 14:20:00</p>
                      </td>
                      <td>
                        <p>Patient Name</p>
                      </td>
                      <td>
                        <p>Dr Pasva Manikandan</p>
                      </td>
                      <td>
                        <p class="centerlaign">In-Progress</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>31/01/2024 | 14:20:00</p>
                      </td>
                      <td>
                        <p>Patient Name</p>
                      </td>
                      <td>
                        <p>Dr Pasva Manikandan</p>
                      </td>
                      <td>
                        <p class="centerlaign">In-Progress</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> -->
            <!-- <app-checkin-dash></app-checkin-dash> -->

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- FRONT DESK -->
<ng-template #fdesk>

  <div class="bodyMain-wrap width-100">
    <div class="px-0 dashboard-mainContainer">
      <div class="row">
        <div class="col-md-12 welcome-wrapper pe-5">
          <h1>WELCOME {{name1}} {{name2}}</h1>
        </div>
      </div>
      <div class="row mainContainer">
        <div class="dashboardBox-wrapper widthAdjust40">
          <div class="creatAppoint">
            <a href="#" routerLink="/appointments/schedule">Create New Appointment</a>
          </div>
          <div class="whiteBg_container flotWidth mb-3">
            <div class="d-flex flex-between">
              <div class="cntntInfo">
                <h2>Today’s Appointments (Online)</h2>
                <div class="d-flex flex-between">
                  <div class="d-flex flex-column countinNmbr">
                    <label>{{a_dashboardvalues?.online_admin_request_count?a_dashboardvalues.online_admin_request_count:'0'}}</label>
                    <span>Requests</span>
                  </div>
                  <div class="d-flex flex-column countinNmbr">
                    <label>
                      {{a_dashboardvalues?.online_admin_schedule_count?a_dashboardvalues.online_admin_schedule_count:'0'}}</label>
                    <span>Schedule</span>
                  </div>
                </div>
              </div>
              <div class="colrBox">
                <img src="/assets/images/appointment.svg" alt="user">
              </div>
            </div>
          </div>
          <div class="whiteBg_container flotWidth mb-3">
            <div class="d-flex flex-between">
              <div class="cntntInfo">
                <h2>Today’s Appointments (In-Person)</h2>
                <div class="d-flex flex-between">
                  <div class="d-flex flex-column countinNmbr">
                    <label>
                      {{a_dashboardvalues?.inperson_admin_schedule_count?a_dashboardvalues.inperson_admin_schedule_count:'0'}}</label>
                    <span><a routerLink="/appointments/Checkin">Scheduled</a></span>
                  </div>
                  <div class="d-flex flex-column countinNmbr">
                    <label>
                      {{a_dashboardvalues?.inperson_admin_checkin_count?a_dashboardvalues.inperson_admin_checkin_count:'0'}}</label>
                    <span>Check In</span>
                  </div>
                </div>
              </div>
              <div class="colrBox redClr">
                <img src="/assets/images/medicalIcon.svg" alt="user">
              </div>
            </div>
          </div>
          <div class="whiteBg_container flotWidth mb-3">
            <div class="d-flex flex-between">
              <div class="cntntInfo">
                <h2>Patient Profile</h2>
              </div>
              <div class="colrBox redClr">
                <img src="/assets/images/patentProfile.svg" alt="user">
              </div>
            </div>
            <div class="d-flex flex-between mt-2 patinetOptin">
              <div class="dBoxpatient">
                <a href="#" routerLink="/profile/patient"><img src="/assets/images/addPateint.svg"
                    alt="user"><span>Create Profile</span></a>
              </div>
              <div class="dBoxpatient">
                <a href="#" routerLink="/profile/search/patient"><img src="/assets/images/editPatient.svg"
                    alt="user"><span>Edit Profile</span></a>
              </div>
              <div class="dBoxpatient">
                <a href="#" routerLink="/profile/delete-patient"><img src="/assets/images/deletePatent.svg"
                    alt="user"><span>Delete Profile</span></a>
              </div>
            </div>
          </div>


        </div>
        <div class="dashboardBox-wrapper widthAdjust60">
          <div class="row">
            <div class="col-md-12 monetseTable mt-0">


              <app-checkin-dash></app-checkin-dash>
              <!-- <h3 class="fontSize19">Today's Inperson Appointments</h3> -->
              <!-- <div class="table-responsive drTable">
                  <table class="table align-middle">
                    <thead>
                      <tr>
                        <th>
                          <p>Date & Time</p>
                        </th>
                        <th>
                          <p>Patient Name</p>
                        </th>
                        <th>
                          <p>Physician Name</p>
                        </th>
                        <th>
                          <p class="centerlaign">Action</p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <p>31/01/2024 | 14:20:00</p>
                        </td>
                        <td>
                          <p>Patient Name</p>
                        </td>
                        <td>
                          <p>Dr Pasva Manikandan</p>
                        </td>
                        <td>
                          <p class="centerlaign">In-Progress</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>30/01/2024 | 12:40:00</p>
                        </td>
                        <td>
                          <p>Patient Name</p>
                        </td>
                        <td>
                          <p>Dr Pasva Manikandan</p>
                        </td>
                        <td>
                          <p class="centerlaign">In-Progress</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div> -->


              <app-checkout-dash></app-checkout-dash>
              <!-- <h3 class="fontSize19">Active Check Ins</h3> -->
              <!-- <div class="table-responsive drTable">
                  <table class="table align-middle">
                    <thead>
                      <tr>
                        <th>
                          <p>Date & Time</p>
                        </th>
                        <th>
                          <p>Patient Name</p>
                        </th>
                        <th>
                          <p>Summary</p>
                        </th>
                        <th>
                          <p>Drugs</p>
                        </th>
                        <th>
                          <p>Labs</p>
                        </th>
                        <th>
                          <p>Bills</p>
                        </th>
                        <th>
                          <p class="centerlaign">Action</p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <p>31/01/2024 | 14:20:00</p>
                        </td>
                        <td>
                          <p>Ezhil k</p>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <p class="actionBtn checkBtn">
                            <a href="#"><img src="/assets/images/checkout.svg" alt="icon"><span>Checkout</span></a>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>31/01/2024 | 14:20:00</p>
                        </td>
                        <td>
                          <p>Ezhil k</p>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <p class="actionBtn checkBtn">
                            <a href="#"><img src="/assets/images/checkout.svg" alt="icon"><span>Checkout</span></a>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>31/01/2024 | 14:20:00</p>
                        </td>
                        <td>
                          <p>Ezhil k</p>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <p class="actionBtn checkBtn">
                            <a href="#"><img src="/assets/images/checkout.svg" alt="icon"><span>Checkout</span></a>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>31/01/2024 | 14:20:00</p>
                        </td>
                        <td>
                          <p>Ezhil k</p>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <p class="actionBtn checkBtn">
                            <a href="#"><img src="/assets/images/checkout.svg" alt="icon"><span>Checkout</span></a>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>31/01/2024 | 14:20:00</p>
                        </td>
                        <td>
                          <p>Ezhil k</p>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <div class="upload-btn-wrapper">
                            <button class="btnUlpd"><img src="/assets/images/uplaodIcon.svg" alt="icon"></button>
                            <input type="file" name="myfile" />
                          </div>
                        </td>
                        <td>
                          <p class="actionBtn checkBtn">
                            <a href="#"><img src="/assets/images/checkout.svg" alt="icon"><span>Checkout</span></a>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div> -->


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>